import { call, put, takeEvery } from "redux-saga/effects";
//  import { channel } from 'redux-saga';
import restClient from "api/restClient";
import { actions as listingActions } from "components/Listing/Listing.reducer";
import { parseParamsForApi } from "components/Listing/Listing.utils";
import NotificationService from "components/Notification/Notification.service";

/**
 * Fetch Listing Saga
 * @param  {Object} promise Resolve and reject promise
 * @param  {Object} params Set query params for listing request
 * @param  {String} entity Name of the listing entity
 * @param  {String} endpoint Endpoint to wich saga points
 * @return {Object} Response from API
 */
export function* fetchListing({ promise, params, entity = "LISTING", endpoint }) {
    try {
        yield put({
            type: `${listingActions.START_FETCH_LISTING}_${entity}`,
        });
        const fetchListingAPI = yield restClient.get(endpoint, {
            params: parseParamsForApi(params),
        });
        yield put({
            type: `${listingActions.SUCCESSFUL_FETCH_LISTING}_${entity}`,
            response: fetchListingAPI?.data,
        });
        if (promise) {
            yield call(promise.resolve, fetchListingAPI?.data);
        }
    } catch (error) {
        yield put({
            type: `${listingActions.FAILED_FETCH_LISTING}_${entity}`,
            response: error?.response?.data || error,
        });
        if (promise) {
            yield call(promise.reject, error?.response?.data || error);
        }
        NotificationService.error(error?.response?.data || error); // TODO (medium) should use <RestErrorNotification> here, but leads to unexpected webpack error
    }
}

/*
function takeLatestPerProps(propsOrSelector, pattern, worker, ...args) {
    // Not a generator
    return fork(function* generator() {
        // Fork a generator here to make it work like takeLatest
        const channelsMap = {};
        while (true) {
            const action = yield take(pattern); // yield necessary here
            const propsValue =
                typeof propsOrSelector === 'function'
                    ? propsOrSelector(action)
                    : action[propsOrSelector];
            if (!channelsMap[propsValue]) {
                channelsMap[propsValue] = channel();
                yield takeLatest(channelsMap[propsValue], worker, ...args);
            }
            yield put(channelsMap[propsValue], action);
        }
    });
}
*/

/**
 * Register action to watcher
 */
export default [takeEvery(listingActions.START_FETCH_LISTING, fetchListing)];
